var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'dinProSemiBold';\n  src: url(" + escape(require("./D-DIN-PRO-600-SemiBold.otf")) + ");\n}\n@font-face {\n  font-family: 'dinProRegular';\n  src: url(" + escape(require("./D-DIN-PRO-400-Regular.otf")) + ");\n}\n\n.semiBold {\n  font-family: 'dinProSemiBold';\n}\n.regular {\n  font-family: 'dinProRegular';\n}\n.pingFang {\n  font-family: 'PingFang SC, PingFang SC';\n  font-weight: 500;\n}\n", ""]);

// exports
